// extracted by mini-css-extract-plugin
module.exports = {"task":"styles_task__2oKHu","valueType":"styles_valueType__3E4VF","criteria":"styles_criteria__2rVt_"};